import * as React from 'react'

import { HeaderView } from './Header.view'

export const Header = ({ openChangeNodeModal }: { openChangeNodeModal: () => void }) => {
  return <HeaderView openModal={openChangeNodeModal} />
}
